import { Navigate, Link } from "react-router-dom";
import ClientList from "./ClientList";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import { useEffect, useState } from "react";
import { MAIN_URL } from "../../../Configurations/Urls";

export default function ClientIndexRedirect() {
  const { userData } = useAuthStore();
  const role = userData?.organizationuser.user_types.user_type_name?.toLowerCase();
  const email = userData.activeOrganizationUser.email;

  const [clientIds, setClientIds] = useState(null);
  const [loadingClient, setLoadingClient] = useState(true);

  useEffect(() => {
    let isMounted = true;
    const fetchClientByEmail = async () => {
      setLoadingClient(true);
      try {
        const token = localStorage.getItem("token");
        const res = await fetch(
          `${MAIN_URL}/api/project-management/clients/by-email/${email}`,
          {
            headers: {
              ...(token && { Authorization: `Bearer ${token}` }),
            },
          }
        );

        if (res.ok) {
          const json = await res.json();
          
          if (isMounted) {
            const clientIdsFromList =json?.data
              
                
            setClientIds(clientIdsFromList);
          }
        } else {
          if (isMounted) setClientIds(null);
        }
      } catch (error) {
        if (isMounted) setClientIds(null);
      } finally {
        if (isMounted) setLoadingClient(false);
      }
    };

    fetchClientByEmail();
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, [email, role]);

  // Not a client user
  if (role !== "client") {
    return <ClientList />;
  }

  if (loadingClient) {
    return (
      <div style={{ padding: "3rem 0", display: "flex", justifyContent: "center" }}>
        <div style={{ 
          border: "4px solid #e3e3e3", 
          borderTop: "4px solid #4285f4",
          borderRadius: "50%",
          width: "36px",
          height: "36px",
          animation: "spin 1s linear infinite"
        }} />
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg);}
              100% { transform: rotate(360deg);}
            }
          `}
        </style>
      </div>
    );
  }

  // No clients
  if (!clientIds || !Array.isArray(clientIds) || clientIds.length === 0) {
    return (
      <div style={{
        textAlign: "center",
        marginTop: "3rem",
        color: "#6b7280",
        fontSize: "1.1rem"
      }}>
        No associated clients found.
      </div>
    );
  }

  // One client, redirect
  if (clientIds.length === 1) {
    return <Navigate to={`/client/info/${clientIds[0].organization_client_id
    }`} replace />;
  }

  // Multiple clients: display nice buttons
  return (
    <div
      style={{
        maxWidth: 420,
        margin: "3.5rem auto 0 auto",
        background: "#fff",
        borderRadius: 18,
        boxShadow: "0 4px 32px rgba(60,60,60,0.11)",
        padding: "2.8rem 1.6rem 2.2rem 1.6rem",
        textAlign: "center",
      }}
    >
      <h2 style={{
        margin: 0,
        marginBottom: 15,
        fontWeight: 700,
        color: "#23304d",
        fontSize: "1.35rem"
      }}>Select a Client</h2>
      <div style={{ marginBottom: 12, color: "#555", fontSize: "1.03rem" }}>
        You are associated with multiple clients. Please choose which client you wish to view:
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 14, marginTop: 24 }}>
        {clientIds.map((cid, idx) => (
          <Link
            key={cid}
            to={`/client/info/${cid.organization_client_id}`}
            style={{
              textDecoration: "none",
              background: "linear-gradient(90deg,#317af4 40%,#2967cc 100%)",
              color: "#fff",
              padding: "0.75rem 0",
              borderRadius: "8px",
              fontWeight: 600,
              fontSize: "1.01rem",
              boxShadow: "0 2px 10px rgba(30,60,125,0.09)",
              letterSpacing: 0.01,
              transition: "background 0.2s, box-shadow 0.12s",
              border: "none",
              outline: "none",
              cursor: "pointer",
              display: "block",
              textShadow: "0 1px 2px rgba(0,0,0,0.06)"
            }}
            onMouseOver={e => e.currentTarget.style.background = "#244b98"}
            onMouseOut={e => e.currentTarget.style.background = "linear-gradient(90deg,#317af4 40%,#2967cc 100%)"}
          >
            {/* Replace with more info if you have, e.g. names */}
          {cid.client_name}
          </Link>
        ))}
      </div>
    </div>
  );
}